import { BaseCall } from '../BaseCall'
import { APIConfig } from '../interfaces'

export class Reports extends BaseCall {

	public getRegReport = (params: any) => this.client.get('/api-v2/reports/reg-report/data', {
			params: params
		}).then((response => response.data))

	public getRegReportByMonth = () => this.client.get('/view/reports/reg-report-by-month')
			.then((response) => response.data)

	public getRegReportByCountry = () => this.client.get('/view/reports/reg-report-country')
			.then((response) => response.data)

	public getRegReportByOs = () => this.client.get('/view/reports/reg-report-os')
			.then((response) => response.data)

	public getRegReportByVersion = () => this.client.get('/view/reports/reg-report-by-version')
			.then((response) => response.data)

	public getRegReportRecentMultipleUsage = () => this.client.get('/view/reports/reg-report-recent-multiple-usage')
			.then((response) => response.data)

	public setConfig(config: APIConfig): void {
		this.setBaseUrl(config.API_SERVER)
	}
}
